import { boolean, object, string } from 'yup';

import { RegexUtils } from '../regex-utils';

function decideTaxIdString(data: string, isInstitution: boolean) {
  if (isInstitution) {
    if (data[0]?.code === 'US') {
      return 'Tax Identification Number';
    }

    if (data[0]?.code === 'IE') {
      return 'VAT ID';
    }

    return 'VAT Number';
  } else {
    if (data[0]?.code === 'UK') {
      return 'National Insurance Number';
    }

    return 'Tax Identification Number';
  }
}

export const taxDetailsValidations = {
  giinAvailable: boolean().required('Please select GIIN availibility'),

  giinNumber: string().required('Please enter a GIIN').matches(RegexUtils.giinRegex, 'Please enter a valid GIIN').max(19, 'Character length exceeded').trim(),

  crsEntity: object()
    .shape({
      value: string().required('Please select CRS Entity'),
      name: string(),
    })
    .nullable()
    .typeError('Please select CRS Entity')
    .required('Please select CRS Entity'),

  crsClassification: object()
    .shape({
      name: string(),
      value: string().required('Please select CRS Classification'),
    })
    .nullable()
    .typeError('Please select CRS Classification')
    .required('Please select CRS Classification'),

  fatcaEntity: object()
    .shape({
      value: string().required('Please select FATCA Entity'),
      name: string(),
    })
    .nullable()
    .typeError('Please select FATCA Entity')
    .required('Please select FATCA Entity'),

  fatcaClassification: object()
    .shape({
      name: string(),
      value: string().required('Please select FATCA Classification'),
    })
    .nullable()
    .typeError('Please select FATCA Classification')
    .required('Please select FATCA Classification'),

  reasonCode: object()
    .shape({
      value: string().required('Please select reason code'),
    })
    .typeError('Please select a valid reason code')
    .required('Please select reason code'),

  taxResidencyCountry: object()
    .shape({
      label: string().required('Please select tax residency country'),
      code: string(),
      phone: string(),
    })
    .nullable()
    .typeError('Please select a valid tax residency country')
    .required(' Please select tax residency country'),

  taxIdentificationNumberInstitution: string().when('taxResidencyCountry', (country: string[]) =>
    string()
      .required(`Please enter ${decideTaxIdString(country, true)}`)
      .matches(RegexUtils.taxIdentificationNumber, "The field can't contain special characters")
      .max(50, 'Character length exceeded')
      .trim()
  ),

  taxIdentificationNumberIndividual: string().when('taxResidencyCountry.code', (country: string[]) =>
    string()
      .required(`Please enter ${decideTaxIdString(country, true)}`)
      .matches(RegexUtils.taxIdentificationNumber, "The field can't contain special characters")
      .max(50, 'Character length exceeded')
      .trim()
  ),
};
